import * as React from 'react';
import ReactJWPlayer from 'react-jw-player';
import { Video, User } from '../../../models';
import './style.css';

export interface VideoPlayerProps {
  currentUser?: User;
  video: Video;
  onPremiumPlaybackBlocked?: () => void;
  onReady?: (event: ReadyParam) => void;
  onPlay?: (event: PlayParam) => void;
}

export interface VideoPlayerState {
  playerId: string;
}

class FixedReactJWPlayer extends ReactJWPlayer {
  _initialize() {
    if (this.videoRef) {
      return super._initialize();
    }
  }
}

export class VideoPlayer extends React.Component<
  VideoPlayerProps,
  VideoPlayerState
> {
  constructor(props: VideoPlayerProps) {
    super(props);

    this.state = {
      playerId: `${props.video.relativeRoute}-player`
    };
  }

  render() {
    const { currentUser, video } = this.props;
    const { playerId } = this.state;

    // Block playback of premium videos for non-premium users
    const blockPremiumPlayback =
      video.isPremium && (!currentUser || !currentUser.isPremium);

    return (
      <FixedReactJWPlayer
        className="edge-of-play-video-container edge-of-play-video-player"
        playerId={playerId}
        playerScript="https://content.jwplatform.com/libraries/MgIShVKi.js"
        file={video.src}
        image={video.poster}
        aspectRatio="16:9"
        isAutoPlay={false}
        {...this.props}
        onPlay={
          blockPremiumPlayback ? this.blockPremiumPlayback : this.props.onPlay
        }
        onResume={blockPremiumPlayback ? this.blockPremiumPlayback : undefined}
      />
    );
  }

  private blockPremiumPlayback: () => void = (): void => {
    const { onPremiumPlaybackBlocked } = this.props;

    const player = jwplayer(this.state.playerId);
    player.stop();

    if (onPremiumPlaybackBlocked) {
      onPremiumPlaybackBlocked();
    }
  };
}

export default VideoPlayer;



// WEBPACK FOOTER //
// ./src/app/components/Video/VideoPlayer/index.tsx